module.exports = __webpack_public_path__ + "files/4d83298d8a0346d602b08ad82598b2a4.svg";